<template>
  <div class="button-style-picker">
    <label for="alignement">{{ label }}</label>
    <ul>
      <li v-for="(key, index) in styles" :key="'align-' + index" @click="onPickItem(key)">
        <svg xmlns="http://www.w3.org/2000/svg" :class="{'is-selected': value === key}"  :viewBox="getSVGDef(key).viewbox" width="100%" height="100%" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <path :d="getSVGDef(key).path" />
        </svg>
        <span class="button-style-picker__label">{{ getLabel(key) }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>

import shapes from "./../shapes/svgicons.json";

const iconDef = {
  "btn-default": {
    icon: "format_align_left",
    label: "default"
  },
  "btn-border": {
    icon: "format_align_center",
    label: "border"
  },
  "btn-border-bottom": {
    icon: "format_align_right",
    label: "bottom"
  }
};

export default {
  name: "buttonStylePicker",
  props: ["modelItem", "value", "options", "label"],
  data() {
    return {
      // options hold the keys to the icons
      styles: this.options,
      icons: iconDef
    };
  },
  methods: {
    getIcon(key) {
      let entry = this.icons[key]
      console.log("getIcon", key, entry)
      return entry ? entry.icon : null
    },
    getSVGDef(key) {
      console.log("getSVGDef, key: , shapes: ", key, shapes)
      let s = shapes[key]
      return s
    },
    getLabel(key) {
      let entry = this.icons[key]
      console.log("getIcon", key, entry)
      return entry ? entry.label : null
    },
    onPickItem(value) {
      console.log('on pick item', value)
      if (this.modelItem) {
        this.modelItem.value = value
      }
      this.$emit('pick', value)
    }
  }
};
</script>
